var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDashedLine = function SvgDashedLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 4,
    viewBox: "0 0 540 4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 4,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_479",
    "data-name": "Repeat Grid 479",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-2",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-3",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-4",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-5",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-6",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-7",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-8",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-9",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-10",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-11",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-12",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-13",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-14",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-15",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-16",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(289.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-17",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-18",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-19",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-20",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-21",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-22",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(409.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-23",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(429.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-24",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(449.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-25",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(469.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-26",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.5 -298.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1229-27",
    "data-name": "Line 1229",
    x2: 11,
    transform: "translate(30.5 298.5)",
    fill: "none",
    stroke: "#dadada",
    strokeWidth: 2
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashedLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashedLine.e70ff5d6.svg";
export { ForwardRef as ReactComponent };